var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-tooltip',_vm._b({attrs:{"content-class":"bg-accent","max-width":"450px"}},'q-tooltip',_vm.$attrs,false),[_c('p',{staticClass:"text-subtitle2 no-margin"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }